import { defineXray } from "../src/xray/manifest.js";
import { extractSecretOps, describeMissing } from "../extractors/secrets/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/secrets/spec.js";
import { SHELL_TOOL_NAMES } from "../src/mine/shell.js";

export default defineXray({
  id: "secrets",
  label: "Secrets",
  title: "Which credentials agents went after and whether they got them — read, enumerated or written, "
    + "granted by the store, refused by it, or blocked by the harness before it ran",

  consumer: "someone auditing what agent sessions did with credential stores",
  decision: "which secrets an agent actually holds, which reads were stopped, and where a credential's value entered a transcript",

  // A secret's name is a durable identifier in someone else's namespace — the
  // strongest target class this pipeline has found.
  tab: true,
  substrate: { label: "shell (credential stores)", match: (n) => SHELL_TOOL_NAMES.test(String(n).split("__").pop()) },
  feed: { domain: "secrets" },
  extract: extractSecretOps, collect, group: build, groupBy, anchor, ignore,
  // The secret's name in its store. An enumeration names none by definition.
  //
  // `text` is "" deliberately, and not as concealment — this lens shows what came
  // back, which is the whole point of its outcome states. It is that a credential
  // value is high-entropy material, so prose-matching it produces coincidental
  // shingles rather than evidence that anything transferred.
  lineage: {
    kind: "secret",
    // `<store>/<entry>` — the entry qualified by the store it lives in. A bare
    // keychain entry resolves too, and identityShapedRef refuses that half.
    citable: true,
    ref: (op) => op.secret || null,
    role: (op) => (op.kind === "write" ? "production" : "consultation"),
    text: () => "",
    label: (op) => `${op.kind} ${op.secret || `all secrets in ${op.store}`}${op.byReference ? " (by the agent's own variable)" : ""}`,
    intent: (op) => (op.valueReachedTrace ? "value entered the trace" : null),
  },

  emptyNote: "No credential-store access in this window",
  explainMissing: describeMissing,
});
